export const transformHousesDataToStreets = (housesData, streetsMap) => {
  if (!housesData || typeof housesData !== 'object') {
    return [];
  }

  return Object.entries(housesData).map(([streetId, houses]) => {
    const streetName = streetsMap.get(streetId) || `Улица ${streetId}`;

    return {
      id: streetId,
      name: streetName,
      description: streetName,
      childrens: houses.map((house) => ({
        ...house,
        postText: streetName,
      })),
    };
  });
};
